export default {
  data: () => ({
    x: 0,
    y: 0,
    selectItem: undefined,
    caption: ''
  }),
  computed: {
    fullPathText() {
      return this.$store.getters.getFullPath.fullPathText
    },
    fullPathUrl() {
      if (this.$store.getters.getFullPath && this.selectItem) {
        let parts = this.$store.getters.getFullPath.fullPathUrl.split('?')
        return `${parts[0]}?${this.selectItem.shareParams}${parts[1]}`
      }
      return this.$store.getters.getFullPath.fullPathUrl
    }
  },
  methods: {
    openContextMenu(item, event) {
      this.x = event.clientX
      this.y = event.clientY
      this.showContextMenu = true
      this.selectItem = item
      event.preventDefault()
    },
    openInNewTab() {
      if (this.selectItem.httpLink) {
        window.open(this.selectItem.httpLink)
        return
      }
      window.open(`${this.$store.getters.getBaseUrl}/?${this.selectItem.shareParams}`)
    },
    toShare() {
      this.$store.dispatch('getFullPath', this.selectItem.codeMenu, this.selectItem.shareParams)
      this.showShareDialog = true
    },
    removeFromFavorite() {
      this.$store.dispatch('removeFromFavorite', this.selectItem.codeMenu)
    },
    renameFunctionMenu(caption) {
      this.$store.dispatch('renameFunctionMenu', { codeMenu: this.selectItem.codeMenu, npp: this.selectItem.npp, caption: caption } )
    },
    openRenameDialog() {
      this.showRenameDialog = true
      this.caption = this.selectItem.name
    },
    closeDialog() {
      this.showRenameDialog = this.showShareDialog = false
      this.selectItem = undefined
    },
    menuSettingsAccess(allUsers) {
      if (window.parent && window.parent.postMessage && window.parent != window) {
        window.parent.postMessage({ type: 'CallMainMenuSettingsAccess', codeMenu: this.selectItem.codeMenu, allUsers: allUsers }, '*')
        return
      }
    }
  }
}